const Joi = require('joi');
  
    
export const VALIDATION_CONTACTS_CREATE = {
    options: {allowUnknownBody: false},
    body: {
        name                                    : Joi.string().required(),
        firstName                               : Joi.string(),
        lastName                                : Joi.string(),
        email                                   : Joi.string(),
        phone                                   : Joi.string(),
        mobile                                  : Joi.string(),
        gender                                  : Joi.string(),
        avatar                                  : Joi.string(),
        position                                : Joi.string(),
        companyTaxCode                          : Joi.string(),
        userId                                  : Joi.string(),
    }
};
    
    
export const VALIDATION_CONTACTS_DELETE = {
    options: {allowUnknownBody: false},
    body: {
        id                                      : Joi.string().required(),
    }
};
    
    
export const VALIDATION_CONTACTS_LIST = {
    options: {allowUnknownBody: false},
    body: {
        companyTaxCode                          : Joi.string().required()
    }
};

export const VALIDATION_CONTACTS_UPDATE = {
  options: {allowUnknownBody: false},
  body: {
    id: Joi.string().required(),
    name: Joi.string(),
    firstName: Joi.string(),
    lastName: Joi.string(),
    email: Joi.string(),
    phone: Joi.string(),
    mobile: Joi.string(),
    avatar: Joi.string(),
    gender: Joi.string(),
    position: Joi.string(),
    companyTaxCode: Joi.string(),
    userId: Joi.string(),
  }
};



// WEBPACK FOOTER //
// ./src/services/contact/Contact.Validator.js